import { useEffect } from 'react'
import { useFormModal } from '@/Ship/Hooks/useFormModal'

export const useDelegateRequestModal = ({ crudContext }: any) => {
    const { Modal, localStorage: delegateModal } = useFormModal({
        fields: {
            responsibleDispatcher: {
                label: 'Диспетчер',
                type: 'select',
                resource: 'Setting.User',
                isRequired: true,
                inputProps: {
                    filter: { status: 'active' },
                    // Exclude the request's current responsible dispatcher — you
                    // cannot delegate a request to the dispatcher who is already
                    // responsible for it. Read the value lazily so it reflects the
                    // request open at delegation time.
                    onAfterSearchRequest: ({ options }: { options: any[] }) => {
                        const current = crudContext?.formContext?.values?.responsibleDispatcher
                        // Collect the current dispatcher's identifiers (id / uuid),
                        // tolerating object, scalar id or an "@id" IRI string.
                        const currentKeys = new Set<string>()
                        if (current && typeof current === 'object') {
                            if (current.id != null) currentKeys.add(String(current.id))
                            if (current.uuid != null) currentKeys.add(String(current.uuid))
                        } else if (current != null) {
                            currentKeys.add(String(current))
                            // "/services/users/<uuid>" → take the trailing segment
                            const tail = String(current).split('/').filter(Boolean).pop()
                            if (tail) currentKeys.add(tail)
                        }
                        if (currentKeys.size === 0) return options
                        return options.filter((opt) => {
                            const item = opt?._original ?? {}
                            const optId = item.id != null ? String(item.id) : null
                            const optUuid = item.uuid != null ? String(item.uuid) : null
                            return !(
                                (optId && currentKeys.has(optId)) ||
                                (optUuid && currentKeys.has(optUuid))
                            )
                        })
                    },
                },
            },
        },
        modalProps: {
            title: 'Делегувати заявку',
            okText: 'Делегувати',
        },
        restUri: '/services/transport-requests/__uuid__/delegate',
        restUriReplaceParams: (uri: string) =>
            uri.replace('__uuid__', crudContext?.formContext?.values?.uuid),
        requestSuccessMessage: 'Заявку делеговано',
        onAfterSuccessRequest: () => crudContext?.actions?.reloadData?.(),
    })

    useEffect(() => {
        const em = crudContext?.eventManager
        if (!em) return

        em.on('requestAction:openDelegateModal', 'delegateModalHandler', () => {
            delegateModal.setIsModalOpen(true)
        })

        return () => em.off('requestAction:openDelegateModal', 'delegateModalHandler')
    }, [crudContext, delegateModal])

    return { Modal }
}
